import { render, staticRenderFns } from "./TickerAdminAddRecommendation.vue?vue&type=template&id=77f0feac"
import script from "./TickerAdminAddRecommendation.vue?vue&type=script&lang=js"
export * from "./TickerAdminAddRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports